import Image from 'next/image'
import { buildSanityImage } from '../../../../modules/utils'

const BlogDetailDesktopMainImageSection = ({ post }) => {
  if (!post.mainImage || Object.keys(post.mainImage).length === 0) {
    return null
  }

  const imageUrl = buildSanityImage(post.mainImage).width(688).height(400).url()
  const blurDataURL = buildSanityImage(post.mainImage).width(20).height(20).blur(10).url()

  return (
    <div className="relative mb-[60px] w-full max-w-[688px] aspect-[688/400]">
      <Image
        alt={post.mainImage.alt || 'Main blog image'}
        src={imageUrl}
        width={688}
        height={400}
        placeholder="blur"
        blurDataURL={blurDataURL}
        priority
        sizes="(max-width: 688px) 100vw, 688px"
      />
    </div>
  )
}

export default BlogDetailDesktopMainImageSection

const style = {
  imageSectionLayout: `relative mb-[60px] h-[400px] w-[688px]`,
}
